import { cx } from "../../utils/cx";
import { getStatusConfig } from "../../config/statusConfig";

const SIZES = {
  sm: "gap-1 rounded-md px-2 py-1 text-xs",
  md: "gap-1.5 rounded-lg px-3 py-1.5 text-sm",
};
const DOTS = { sm: "h-1.5 w-1.5", md: "h-2 w-2" };

/**
 * A status from the shared status config. Variants: soft (tinted, default), solid, outline, minimal.
 */
export function StatusBadge({ status, label, variant = "soft", size = "sm", showDot = true, className }) {
  const { label: configLabel, color } = getStatusConfig(status);
  const styles = {
    soft: { style: { backgroundColor: `${color}20` }, text: "text-slate-800", dot: color },
    solid: { style: { backgroundColor: color }, text: "text-white", dot: "#fff" },
    outline: { style: { borderColor: color }, text: "border-2 text-slate-700", dot: color },
    minimal: { style: {}, text: "bg-gray-100 text-gray-600", dot: color },
  }[variant];

  return (
    <span className={cx("inline-flex w-fit items-center whitespace-nowrap font-medium", SIZES[size], styles.text, className)} style={styles.style}>
      {showDot && <span className={cx("rounded-full", DOTS[size])} style={{ backgroundColor: styles.dot }} />}
      {label ?? configLabel}
    </span>
  );
}

const TAG_COLORS = {
  gray: "bg-slate-100 text-slate-700",
  brand: "bg-brand/10 text-brand",
  blue: "bg-blue-100 text-blue-800",
  green: "bg-green-100 text-green-800",
  yellow: "bg-yellow-100 text-yellow-800",
  red: "bg-red-100 text-red-800",
};

// Small neutral label for non-status values (categories, types, years)
export function Tag({ color = "gray", className, children }) {
  return <span className={cx("inline-flex w-fit items-center rounded-md px-2 py-1 text-xs font-medium", TAG_COLORS[color], className)}>{children}</span>;
}
